
  import pageMeta from '~/mixins/pageMeta.js';

export default {
  name: 'FiveStarProductsAwardProductsV2',
  mixins: [pageMeta],

  props: {
    data: {
      type: Array,
      default: () => ([]),
    },
    dataLoading: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    return {
      remarksIsActive: 0,

    }
  },

  computed: {
    pageData() {
        return this.subcategory;
    },
    subcategory() {
      if (this.data?.length === 1) {
        console.debug('single subCat in award product')
        return this.data[0]
      }
      if (!this.$route?.params?.any2 && this.data?.length > 0) {
        return this.data[0]
      }
      return this.data?.find((item) => {
        return (item.Slug === this.$route?.params?.any2)
      })
    },
  },

  methods: {
    toggleRemark() {
      this.remarksIsActive = !this.remarksIsActive
    },
    extractH2FromRemarks(htmlContent) {
      const reg = /(.*?)<h2>(.*?)<\/h2>(.*)/s
      const match = htmlContent.match(reg)
      if (match) {
        return [match[1], match[2], match[3]]
      }
      return [null, htmlContent]
    },
  }

}
